// extracted by mini-css-extract-plugin
export default {"animate-on-value-change":"animate-on-value-change--vaPOz","animateOnValueChange":"animate-on-value-change--vaPOz","animate":"animate--H4tSO"};